import React, { Component } from "react";
import { withRouter } from "../../../withRouter";
import { Autocomplete } from "@mui/material";
import TextField from "@material-ui/core/TextField";
import FetchServerData from "../../../provider/FetchServerData";
import { Buffer } from "buffer";
import Pagination from "../../assetTracking/Pagination";
import Button from "@material-ui/core/Button";
import store from "../../../redux/store";
import Utils from "../../../provider/Utils";
import PtsAlert from "../../ptsAlert/PtsAlert";

class SupplierTrackingHistory extends Component {
    header = store.getState().header.header;


    constructor() {
        super();
        this.state = {
            assetTrackingHistoryList: [],
            render: false,
            searchText: "",
            pageNo: 0,
            showPerPage: 0,
            pageSize: 10,
            trackingMapList: [],
            search: "",
            supplier: null,
            supplierId: "",
            supplierList: [],
            activeAssetList: [],
            inActiveAssetList: [],
            inCycleAssetList: [],
            damagedAssetList: [],
            assetCodes: [],
            selectedAssetCode: null,
            directionOptions: [
                { value: "IN", label: "IN" },
                { value: "OUT", label: "OUT" },
            ],
            selectedDirection: null,
            startDate: "",
            endDate: "",
        };
        this.getSupplierList();
    }

    getSupplierList() {
        const postObject = {
            header: this.header,
        };
        FetchServerData.callPostService(
            "/supplierms/getList",
            postObject
        ).then((output) => {
            if (output.status === "SUCCESS") {
                let supplierListArray = output.data.supplierList;
                this.setState({
                    supplierList: supplierListArray,
                });
            }
        });
    }

    handleSupplierTypeChange(selectedSupplier) {
        this.setState({
            supplier: selectedSupplier,
            supplierId: selectedSupplier.id,
            selectedAssetCode: null,
            selectedDirection: null,
            startDate: "",
            endDate: "",
        });
        this.getSupplierStaticData(selectedSupplier.id);
    }

    getSupplierHistory(pageNo, pageSize) {

        if (this.state.supplierId === "" || this.state.supplierId === null) {
            PtsAlert.error("Please select supplier");
            return;
        }
        const postObject = {
            header: this.header,
            supplier: {
                id: this.state.supplierId,
            },
            page: {
                searchText: "",
                pageNo: pageNo,
                pageSize: pageSize,
            },
            assetCode: {
                id: this.state.selectedAssetCode ? this.state.selectedAssetCode.id : ""
            },
            action: this.state.selectedDirection ? this.state.selectedDirection.value : "",
            startDate: this.state.startDate,
            endDate: this.state.endDate
        };

        FetchServerData.callPostService("/misms/supplierAssetTracking", postObject).then(
            (output) => {
                if (output.status === "SUCCESS") {

                    let trackingDetails = output.data;
                    let assetHistoryList = output.data.history;
                    for (let i = 0; i < assetHistoryList.length; i++) {
                        assetHistoryList[i].sortDate = assetHistoryList[i].tdate;
                        assetHistoryList[i].tdate = Utils.getUtcToLocalDateTime(assetHistoryList[i].tdate);
                        assetHistoryList[i].tenddate = Utils.getUtcToLocalDateTime(assetHistoryList[i].tenddate);
                    }
                    console.log("assetHistoryList", assetHistoryList);
                    this.setState({
                        render: true,
                        assetTrackingHistoryList: assetHistoryList,
                        pageNo: trackingDetails.page.pageNo,
                        showPerPage: trackingDetails.page.pageSize,
                        totalPages: trackingDetails.page.totalPages,
                        totalRecords: trackingDetails.page.total,
                        trackingMapList: assetHistoryList,
                    });
                }
            }
        );
    }
    getSupplierStaticData(supplierId) {

        const postObject = {
            header: this.header,
            supplier: {
                id: supplierId,
            },
        };

        FetchServerData.callPostService("/supplierAnalyticms/getSupplierStaticData", postObject).then(
            (output) => {
                if (output.status === "SUCCESS") {
                    let supplierDetails = output.data;
                    this.setState({
                        assetCodes: supplierDetails.assetCodes || [],
                        selectedAssetCode: null,
                    });
                }
            }
        );
    }
    handleStartDateChange(event) {
        this.setState({ startDate: event.target.value });
    }

    handleEndDateChange(event) {
        this.setState({ endDate: event.target.value });
    }

    clearFilters() {
        this.setState({
            supplier: null,
            supplierId: "",
            selectedAssetCode: null,
            selectedDirection: null,
            startDate: "",
            endDate: "",
            assetTrackingHistoryList: [],
            pageNo: 0,
            showPerPage: 0,
            totalPages: 0,
            totalRecords: 0,
            trackingMapList: [],
        });
    }

    downloadExcel() {
        const postObject = {
            header: this.header,
            supplier: {
                id: this.state.supplierId,
            },
            assetCode: {
                id: this.state.selectedAssetCode ? this.state.selectedAssetCode.id : ""
            },
            action: this.state.selectedDirection ? this.state.selectedDirection.value : "",
            startDate: this.state.startDate,
            endDate: this.state.endDate
        };

        FetchServerData.callPostService(
            "/misms/exportSupplierTrackingHistoryData",
            postObject
        ).then((output) => {
            if (output.status === "SUCCESS") {
                const byteArray = new Buffer(
                    output.data.data.replace(/^[\w\d;:\/]+base64\,/g, ""),
                    "base64"
                );
                const outputFilename = output.data.fileName;
                const url = URL.createObjectURL(new Blob([byteArray]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", outputFilename);
                document.body.appendChild(link);
                link.click();
            }
        });
    }

    onPaginationChange(returnProp) {
        let counter = returnProp.counter;
        let pageNo = this.state.pageNo + counter;
        let pageSize = returnProp.showPerPage;
        let buttonIndex = returnProp.buttonIndex;
        let currentPageIndex =
            typeof counter !== "undefined" ? pageNo : buttonIndex;
        let resetPageNo = returnProp.resetPageNo;
        if (resetPageNo === true) {
            currentPageIndex = 0;
        }
        this.setState({
            pageNo: currentPageIndex,
        });
        this.getSupplierHistory(currentPageIndex, pageSize);
    }
    render() {
        return (


            <div className="row">
                <div className="col-md-12 pb-3">
                    <div className="card">
                        <div className="card-body">
                            <div className="row gx-2 gy-2 align-items-end">
                                <div className="col-md-2 mt-1" id="assetFormLabel">
                                    <label
                                        className="form-label mb-1"
                                        htmlFor="collapsible-supplierType"
                                    >
                                        Select Supplier <span className="asterisk"> *</span>
                                    </label>
                                    <Autocomplete
                                        fullWidth
                                        disableClearable
                                        size="small"
                                        id="supplierTypeList"
                                        options={this.state.supplierList}
                                        value={this.state.supplier}
                                        defaultValue={this.state.supplier}
                                        getOptionLabel={(option) => option.name}
                                        onChange={(event, value) => {
                                            this.handleSupplierTypeChange(value);
                                        }}
                                        inputprops={{
                                            style: { textTransform: "capitalize" },
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                placeholder="Please Select"
                                                variant="outlined"
                                                size="small"
                                                required
                                            />
                                        )}
                                    />
                                </div>
                                <div className="col-md-2 mt-1" id="assetFormLabel">
                                    <label
                                        className="form-label mb-1"
                                        htmlFor="collapsible-assetCode"
                                    >
                                        Asset Code
                                    </label>
                                    <Autocomplete
                                        fullWidth
                                        size="small"
                                        id="assetCodeList"
                                        options={this.state.assetCodes}
                                        value={this.state.selectedAssetCode}
                                        getOptionLabel={(option) => option.code || ""}
                                        onChange={(event, value) => {
                                            this.setState({ selectedAssetCode: value });
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                placeholder="Select Asset Code"
                                                variant="outlined"
                                                size="small"
                                            />
                                        )}
                                    />
                                </div>
                                <div className="col-md-1 mt-1" id="assetFormLabel">
                                    <label
                                        className="form-label mb-1"
                                        htmlFor="collapsible-direction"
                                    >
                                        Direction
                                    </label>
                                    <Autocomplete
                                        fullWidth
                                        size="small"
                                        id="directionList"
                                        options={this.state.directionOptions}
                                        value={this.state.selectedDirection}
                                        getOptionLabel={(option) => option.label || ""}
                                        onChange={(event, value) => {
                                            this.setState({ selectedDirection: value });
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                placeholder="Direction"
                                                variant="outlined"
                                                size="small"
                                            />
                                        )}
                                    />
                                </div>
                                <div className="col-md-2 mt-1" id="assetFormLabel">
                                    <label
                                        className="form-label mb-1"
                                        htmlFor="collapsible-startDate"
                                    >
                                        Start Date
                                    </label>
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        size="small"
                                        id="startDate"
                                        type="date"
                                        value={this.state.startDate}
                                        onChange={this.handleStartDateChange.bind(this)}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        InputProps={{
                                            style: {
                                                backgroundColor: "#fff",
                                                borderRadius: "6px",
                                            }
                                        }}
                                    />
                                </div>
                                <div className="col-md-2 mt-1" id="assetFormLabel">
                                    <label
                                        className="form-label mb-1"
                                        htmlFor="collapsible-endDate"
                                    >
                                        End Date
                                    </label>
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        size="small"
                                        id="endDate"
                                        type="date"
                                        value={this.state.endDate}
                                        onChange={this.handleEndDateChange.bind(this)}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        InputProps={{
                                            style: {
                                                backgroundColor: "#fff",
                                                borderRadius: "6px",
                                            }
                                        }}
                                    />
                                </div>
                                <div className="col-auto pt-4">
                                    <button
                                        style={{
                                            width: "100%",
                                            padding: "7px",
                                            fontSize: "14px",
                                            fontWeight: "600",
                                            backgroundColor: "#0B6F9D",
                                            color: "#fff",
                                            border: "none",
                                            borderRadius: "7px",
                                            alignItem: "center",
                                        }}
                                        onClick={() => {
                                            this.getSupplierHistory(this.state.pageNo, this.state.pageSize);
                                        }}
                                    >
                                        Filter
                                    </button>
                                </div>
                                <div className="col-auto pt-4">
                                    <button
                                        style={{
                                            width: "100%",
                                            padding: "7px",
                                            fontSize: "14px",
                                            fontWeight: "600",
                                            backgroundColor: "#6c757d",
                                            color: "#fff",
                                            border: "none",
                                            borderRadius: "7px",
                                            alignItem: "center",
                                        }}
                                        onClick={this.clearFilters.bind(this)}
                                    >
                                        Clear
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                {
                    this.state.assetTrackingHistoryList.length > 0 && (
                        <div className="card">

                            <div className='row justify-content-between p-3 pb-1'>
                                <div className="col-auto mb-2">
                                    <span style={{ color: 'black', fontWeight: 'bold' }}>Total Results: {this.state.totalRecords}</span>
                                </div>
                                <div className="col-auto mb-2">
                                    <Button
                                        variant="contained"
                                        size="small"
                                        id="excelBtn"
                                        startIcon={<i class="fa fa-download"></i>}
                                        onClick={this.downloadExcel.bind(this)}
                                    >
                                        Download Excel
                                    </Button>
                                </div>
                                <div className="table-responsive paginationTable">
                                    <table className="table text-start table-hover">
                                        <thead
                                            className="paginationTableThead"
                                            style={{ background: "#0B6F9D", color: "#fff" }}
                                        >
                                            <tr>
                                                <th>#</th>
                                                <th>Plan Name</th>
                                                <th>First Track Date</th>
                                                <th>Latest Track Date</th>
                                                <th>Created by</th>
                                                <th>Action</th>
                                                <th>Count</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.assetTrackingHistoryList?.map(
                                                (rowData, index) => (
                                                    <tr key={index}>
                                                        <td>{this.state.pageNo * this.state.showPerPage + index + 1}</td>
                                                        <td style={{ width: "280px" }}>{rowData.planName}</td>
                                                        <td style={{ width: "280px" }}>{rowData.tdate}</td>
                                                        <td style={{ width: "280px" }}>{rowData.tenddate}</td>
                                                        <td style={{ width: "220px" }}>{rowData.createdbyName}</td>
                                                        <td style={{ width: "150px" }}>{rowData.action}</td>
                                                        <td style={{ width: "120px" }}>{rowData.count}</td>
                                                    </tr>
                                                )
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                                {this.state.totalRecords > this.state.pageSize &&
                                    <div className="row justify-content-between pagination p-1">
                                        <div className="pageSize col-4 text-start">
                                            Page {this.state.pageNo + 1} of {this.state.totalPages}
                                        </div>
                                        <div className="col-4 text-end">
                                            <Pagination
                                                showPerPage={this.state.showPerPage}
                                                onPaginationChange={this.onPaginationChange.bind(
                                                    this
                                                )}
                                                total={this.state.totalRecords}
                                            />
                                        </div>
                                    </div>
                                }
                            </div>

                        </div>
                    )
                }

            </div>

        );
    }
}
export default withRouter(SupplierTrackingHistory);
